export default __webpack_public_path__ + "static/media/pop-dropdown.147b9d04.webp";